import { create } from 'zustand';

export const useStore = create((set) => ({
  // Session
  sessionId: null,
  userRole: null,
  setSession: (id, role) => set({ sessionId: id, userRole: role }),

  // Ajoute ces deux fonctions dans ton create()
updateAnnotation: (id, updates) => set((state) => ({
  annotations: state.annotations.map(a => 
    a.id === id ? { ...a, ...updates } : a
  )
})),

setAnnotations: (newAnnotations) => set({ annotations: newAnnotations }),
  
  // Annotations AR
  annotations: [],
  addAnnotation: (annotation) => set((state) => ({
    annotations: [...state.annotations, annotation]
  })),
  removeAnnotation: (id) => set((state) => ({
    annotations: state.annotations.filter(a => a.id !== id)
  })),
  clearAnnotations: () => set({ annotations: [] }),
  
  // Pose caméra (SLAM)
  cameraPose: { 
    position: [0, 0, 0], 
    quaternion: [0, 0, 0, 1] 
  },
  setCameraPose: (pose) => set({ cameraPose: pose }),
  
  // Outils expert
  activeTool: 'arrow',
  setActiveTool: (tool) => set({ activeTool: tool }),
  annotationColor: '#ff0000',
  setAnnotationColor: (color) => set({ annotationColor: color }),
  
  // Connexion
  isConnected: false,
  setIsConnected: (connected) => set({ isConnected: connected }),
  latency: 0,
  setLatency: (ms) => set({ latency: ms })
}));